import { Component, type ErrorInfo, type ReactNode } from 'react';

// Bez této pojistky shodí jakákoli chyba při vykreslení celou aplikaci na
// prázdnou bílou stránku a uživatel nemá co nahlásit. Místo toho ukážeme, co
// se stalo, a necháme ho pokračovat bez ztráty rozdělané práce v jiné záložce.
interface Props { children: ReactNode }
interface State { error: Error | null }

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[P1] Neočekávaná chyba v aplikaci:', error, info.componentStack);
  }

  override render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div style={{
        maxWidth: 560, margin: '80px auto', padding: '28px 32px',
        border: '1px solid #e9ecef', borderRadius: 14, background: '#fff',
        font: '14px/1.55 system-ui, -apple-system, "Segoe UI", sans-serif', color: '#25282a',
      }}>
        <h1 style={{ margin: '0 0 8px', fontSize: 19, fontWeight: 650 }}>Něco se pokazilo</h1>
        <p style={{ margin: '0 0 18px', color: '#6b7280' }}>
          Stránku se nepodařilo zobrazit. Zkuste ji načíst znovu, nebo se vraťte zpět.
        </p>
        <pre style={{
          margin: '0 0 20px', padding: '10px 12px', borderRadius: 8, background: '#f6f7f8',
          color: '#b42318', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        }}>{error.message || String(error)}</pre>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px', border: 0, borderRadius: 8,
              background: '#137333', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >Načíst znovu</button>
          <button
            type="button"
            onClick={() => { this.setState({ error: null }); window.history.back(); }}
            style={{
              padding: '8px 16px', border: '1px solid #d7dbdf', borderRadius: 8,
              background: '#fff', fontSize: 13, cursor: 'pointer',
            }}
          >Zpět</button>
        </div>
      </div>
    );
  }
}
